import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';

const TransportTableComponent = ({ rowData }) => {
	const transports = rowData.value;

	if (!Array.isArray(transports) || transports.length === 0) {
		return <span>{transports || '---'}</span>;
	}

	return (
		<div className="transport-table">
			{transports.map(transport => (
				<div key={transport.id} className="transport-row">
					<div className="transport-cell transport-cell_type">{transport.car_type?.name || '---'}</div>
					<div className="transport-cell transport-cell_tonnage">
						{transport.tonnage?.name ? `${transport.tonnage.name} т` : '---'}
					</div>
					<div className="transport-cell">
						{transport.quantity != null ? `${transport.quantity} шт` : '---'}
					</div>
				</div>
			))}
		</div>
	);
};

TransportTableComponent.propTypes = {
	rowData: PropTypes.shape({
		value: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.arrayOf(
				PropTypes.shape({
					car_type: PropTypes.shape({
						name: PropTypes.string,
					}),
					tonnage: PropTypes.shape({
						name: PropTypes.string,
					}),
					quantity: PropTypes.number,
				}),
			),
		]),
	}).isRequired,
};

export { TransportTableComponent };
